function treeFind (tree, id) {
  for (const data of tree) {
    if (data.id == id) return data
    if (data.children) {
      const res = treeFind(data.children, id)
      if (res) return res
    }
  }
  return ""
}

function getChidlren(tree,id){
  var hasFound = false; // 表示是否有找到id值
  let result  = null ; 
  var fn = function(tree){
    if(Array.isArray(tree) && !hasFound){ // 判断是否是数组并且没有的情况下，
      tree.forEach(item =>{
        if(item.id === id){// 数据循环每个子项，并且判断子项下边是否有id值
          result = item; // 返回的结果等于每一项
          hasFound = true; // 并且找到id
        }else if(item.children){
          fn(item.children); // 递归调用下边的子项
        }
      })
    }
  }
  fn(data); // 调用一下
  return result;
}

const getters = {
  token: state => state.user.token,
  userInfo: state => state.user.userInfo,


  industry:state => state.industry.list,  //所属行业
  comanyIndustry:state => state.industry.comany,   //企业用户的所属行业
  newCount:state => state.industry.count,
  
  itemIndutry:(state) => (id) => {
       if(!state.industry.list.length)return
      //  let industryList = state.industry.list[0].children;
       let result =  treeFind(state.industry.list,id);
       return result ? result.name :""
  },
  comyIndustry:(state)=>(id)=>{
     if(!state.industry.comany.length)return
     let result = treeFind(state.industry.comany,id);
     return result ? result.name :""
  },

  companyInfo:(state) =>{
    return state.company.baseInfo
  }
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js